module.exports = __webpack_public_path__ + "img/mit.72dc9f1c.png";